import { render, staticRenderFns } from "./LoadMoreColumnsBtn.vue?vue&type=template&id=35250718&scoped=true"
import script from "./LoadMoreColumnsBtn.vue?vue&type=script&lang=js"
export * from "./LoadMoreColumnsBtn.vue?vue&type=script&lang=js"
import style0 from "./LoadMoreColumnsBtn.vue?vue&type=style&index=0&id=35250718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35250718",
  null
  
)

export default component.exports